const eligibleTags: Record<string, boolean> = { A: true, BUTTON: true };

function getViewport() {
  const width = window.innerWidth;
  const isMobile = width < 600;
  const isTablet = width > 600 && width < 1024;

  if (isMobile) return 'mobile';
  if (isTablet) return 'tab';
  return 'pc';
}

export function getAssemblerPageViewTagData() {
  const site = window.location.href;
  const experienceType = getViewport();
  const previousPage = window.sessionStorage.getItem('previousPage');

  const currentPage = window.location.pathname;
  if (currentPage !== previousPage) {
    window.sessionStorage.setItem('previousPage', currentPage);
  }

  return { site, experienceType, previousPage };
}

const isClickTagEligible = (element: HTMLElement) => {
  return eligibleTags[element.tagName] && (element.dataset.linkName || element.dataset.onClickLinkName) && element.dataset.onClick;
};

const findButton = (element: HTMLElement): HTMLButtonElement | null => {
  if (element && element.tagName !== 'BODY') {
    if (isClickTagEligible(element)) {
      return element as HTMLButtonElement;
    }
    return element.parentElement ? findButton(element.parentElement) : null;
  }
  return null;
};

const fireClickButton = (linkName: string, onclick: string) => {
  if (!linkName?.trim().length && !onclick?.trim().length) return;

  window.digitaldata = { ...(window.digitaldata || {}), onclick: { linkName, onclick } };

  window._satellite.track('ford-credit-global-onclick');
};

export function setupButtonTags(e: MouseEvent) {
  const button = findButton(e.target as HTMLElement);
  if (button) {
    fireClickButton(button.dataset.linkName ?? button.dataset.onClickLinkName ?? '', button.dataset.onClick ?? '');
  }
}
